import Layout from "../include/layout";
import { Button, Container, Form, Modal, Table } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "datatables.net-bs5";
import EnseignantsService from "./EnseignantsService";
import Filarial from "../include/filarial";
import PersonnesService from "../personnes/PersonnesService";
import MatieresService from "../matieres/MatieresService";
import UsersService from "../users/UsersService";
import CivilitesService from "../civilites/CivilitesService";
import PaysService from "../pays/PaysService";
import TypescontratsService from "../typescontrats/TypescontratsService";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import ClassesService from "../classe/ClassesService";
import { ConnectedOverlayScrollHandler } from "primereact/utils";

export default function EnseignantIndex() {
  const activeLink = "ENSEIGNANTS";

  const navigate = useNavigate();
  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);

  ///les elements du modal details
  const token = useSelector((state) => state.auth.token);
  const [enseignants, setEnseignants] = useState([]);
  const [personnes, setPersonnes] = useState([]);
  const [users, setUsers] = useState([]);
  const [sexe, setSexes] = useState([]);
  const [civilites, setCivilites] = useState([]);
  const [nom, setNom] = useState("");
  const [prenoms, setPrenoms] = useState("");
  const [ifuEnseignant, setIfuEnseignant] = useState("");
  const [cnssEnseignant, setCnssEnseignant] = useState("");
  const [telephone, setTelephone] = useState("");
  const [matiere, setMatiere] = useState("");
  const [matieres, setMatieres] = useState([]);
  const [email, setEmail] = useState("");
  const [civilite, setCivilite] = useState("");
  const [nationalite, setNationalite] = useState("");
  const [nationalites, setNationalites] = useState([]);
  const [classeoptions, setClasseoptions] = useState([]);
  const [classeoption, setClasseoption] = useState("");
  const [classes, setClasses] = useState([]);
  const [idenseignant, setIdenseignant] = useState("");
  const [classesmatieresenseignants, setClassesmatieresenseignants] = useState(
    []
  );
  const [classesmatieres, setClassesmatieres] = useState([]);
  const [classe, setClasse] = useState("");
  const [lieuNaissance, setLieuNaissance] = useState("");
  const [pays, setPays] = useState("");
  const [ddn, setDdn] = useState("");
  const [typecontrat, setTypescontrat] = useState("");
  const [typecontrats, setTypescontrats] = useState([]);
  const [debutcontratEnseignant, setDebutcontrat] = useState("");
  const [fincontratEnseignant, setFincontrat] = useState("");
  const [diplomeEnseignant, setDiplomeEnseignant] = useState("");
  const [salaireEnseignant, setSalaireEnseignant] = useState("");

  //Enseignant sélectionné
  const [idElement, setIdElement] = useState("");

  //get liste enseignants
  const fetchEnseignants = async () => {
    await EnseignantsService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setEnseignants(res.data.data.enseignants);
      })
      .catch((error) => {
        console.log(error);
      });
       //initialize datatable
       $(document).ready(function () {
        $('.data-table').DataTable();
    });
  };

  //get liste personnes
  const fetchPersonnes = async () => {
    await PersonnesService.index(token)
      .then((res) => {
        //  console.log(res.data.data.personnes)
        setPersonnes(res.data.data.personnes);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste users
  const fetchUsers = async () => {
    await UsersService.index(token)
      .then((res) => {
        setUsers(res.data.data.users);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste types contrats
  const fetchTypescontrats = async () => {
    await TypescontratsService.index(token)
      .then((res) => {
        setTypescontrats(res.data.data.typescontrats);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste matières
  const fetchMatieres = async () => {
    await MatieresService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setMatieres(res.data.data.matieres);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste civilites
  const fetchCivilites = async () => {
    await CivilitesService.index(token)
      .then((res) => {
        setCivilites(res.data.data.matieres);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste nationalites
  const fetchNationalites = async () => {
    await PaysService.nationalites(token)
      .then((response) => {
        setNationalites(response.data.data.nationalites);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste classesmatieresenseignants
  const fetchClassesmatieresenseignants = async () => {
    await ClassesService.classesmatieresenseignants(token)
      .then((response) => {
        // console.log(response.data.data.classesmatieresenseignants)
        setClassesmatieresenseignants(
          response.data.data.classesmatieresenseignants
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste classesmatieress
  const fetchClassesmatieres = async () => {
    await ClassesService.classesmatieres(token)
      .then((response) => {
        //console.log(response.data.data.classesmatieres)
        setClassesmatieres(response.data.data.classesmatieres);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  ///Get liste des classesoptions
  const fetchClassesoptions = async () => {
    await ClassesoptionsService.index(token)
      .then((res) => {
        setClasseoptions(res.data.data.classesoptions);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste pays
  const fetchPays = async () => {
    await PaysService.index(token)
      .then((response) => {
        setNationalites(response.data.data.nationalites);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste personnes
  const fetchSexes = async () => {
    await PersonnesService.index(token)
      .then((res) => {
        //console.log(res.data.data.sexes)
        setSexes(res.data.data.sexes);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  //redirection sur la page edit sans afficher les id dans l'url
  const goToEdit = (param) => {
    navigate(myroutes.enseignants_edit, { state: { id: param } });
  };

  const onDelete = (param) => {
    // Confirm action
    Swal.fire({
      icon: "warning",
      text: "Voulez-vous confirmer cette action ?",
      showCancelButton: true,
      cancelButtonText: "Non",
      confirmButtonText: "Oui",
      confirmButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("ID de l'enseignant à supprimer:", param);
        EnseignantsService.delete(param, token)
          .then((response) => {
           
            if (response.data.status !== 200) {
              Swal.fire({
                icon: "error",
                text: response.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                text: response.data.message,
              }).then(() => {
                fetchEnseignants();
              });
            }
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              text: e.message,
            });
          });
      }
    });
  };
  

  //Afficher le modal de détail user
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDetails = (id) => {
    const enseignant = enseignants.find((e) => e.id === id);
    const idenseignant = enseignant.id
    const personne = enseignant.personnes;
    const user = enseignant.personnes.users;
    const nom = personne.nomPersonne;
    const ddn = personne.ddn;
    const lieuNaissance = personne.lieuNaissance;
    const prenoms = personne.prenomsPersonne;
    const telephone = personne.telephonePersonne;
    const email = user.email;
    const matiere = enseignant.matieres
      ? enseignant.matieres.libelleMatiere
      : "Aucune matière associée";
    const civilite =
      enseignant.personnes && enseignant.personnes.civilites
        ? enseignant.personnes.civilites.libelleCivilite
        : null;
    const sexe = enseignant.sexes
      ? enseignant.sexes.libelleSexe
      : "Aucun sexe associée";
    const typecontrat = enseignant.typescontrats
      ? enseignant.typescontrats.libelleTypecontrat
      : "Aucun sexe associée";
    const nationalite = enseignant.nationalites
      ? enseignant.nationalites.libelleNationalite
      : "Aucune nationalite associée";
    const pays =
      enseignant.personnes && enseignant.personnes.pays
        ? enseignant.personnes.pays.nompaysPays
        : null;

    // récupérer le libelle de la classe associée à l'enseignant

    // (1) Récupérer l'id associé à l'enseignant
  /*  const enseignantId = enseignant.id;

    // (2) Récupérer les informations relatives à la classesmatieresenseignants associé à l'enseignant
    const classeMatiereEnseignant = classesmatieresenseignants.find(item => item.enseignants.id === enseignantId);

   // (3) Récupérer le libelle de la ou les classesoptions associé à l'enseignant
    const classe = classeMatiereEnseignant ? classeMatiereEnseignant.classesoptions.libelleClasseOption : null;
    
    console.log(classeMatiereEnseignant);*/

    // (1) Récupérer l'id associé à l'enseignant
    const enseignantId = enseignant.id;

    // (2) Filtrer les classesmatieresenseignants associés à l'enseignant
    const classesOptionsEnseignant = classesmatieresenseignants.filter(item => item.enseignants.id === enseignantId);

    // (3) Récupérer les libelles des classesoptions associées à l'enseignant
    const classe = classesOptionsEnseignant.map(item => item.classesoptions.libelleClasseOption);

   /* console.log(classesOptionsEnseignant);
    console.log(classe);*/



    // Mettez à jour l'état local avec les détails de l'enseignant spécifique
    setIdenseignant(idenseignant)
    setNom(nom);
    setPrenoms(prenoms);
    setTelephone(telephone);
    setEmail(email);
    setIfuEnseignant(enseignant.ifuEnseignant);
    setCnssEnseignant(enseignant.cnssEnseignant);
    setDiplomeEnseignant(enseignant.diplomeEnseignant);
    setSalaireEnseignant(enseignant.salaireEnseignant);
    setDebutcontrat(enseignant.debutcontratEnseignant);
    setFincontrat(enseignant.fincontratEnseignant);
    setMatiere(matiere);
    setCivilite(civilite);
    setSexes(sexe);
    setNationalite(nationalite);
    setPays(pays);
    setDdn(ddn);
    setLieuNaissance(lieuNaissance);
    setTypescontrat(typecontrat);
    setClasse(classe);
    handleShow();
  };

  //redirection sur la page edit sans afficher les id dans l'url
  const  handleClickemploidutemps = (idenseignant) => {
   // console.log("id = ", idenseignant)
    navigate(myroutes.emploidutemps_enseignants, { state: { id: idenseignant } });
  };

  
  useEffect(() => {
    fetchEnseignants();
    fetchPersonnes();
    fetchUsers();
    fetchCivilites();
    fetchClassesoptions();
    fetchSexes();
    fetchNationalites();
    fetchTypescontrats();
    fetchPays();
    fetchMatieres();
    fetchClassesmatieresenseignants();
    fetchClassesmatieres();
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }
  }, [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />

        {/* Responsive Datatable */}
        <div className="card shadow-lg mb-3 mt-3">
          <h5 className="card-header">
            Liste des enseignants{" "}
            <Link
              className="btn btn-primary btn-sm"
              to={myroutes.enseignants_create}
              title="Ajouter"
            >
              <FontAwesomeIcon icon="fa-solid fa-circle-plus" />
            </Link>
          </h5>
          <div className="card-datatable table-responsive px-4 pb-3">
            <table className="dt-responsive table border-top data-table table-hover ">
              <thead className="fw-bold theme-bg-blue-white ">
                <tr style={{ color: "" }}>
                  <th className="cell">Numéro Maticule</th>
                  <th className="cell">Nom et Prénom(s)</th>
                  <th className="cell">Date Naissance</th>
                  <th className="cell">Sexe</th>
                  <th className="cell">Diplôme</th>
                  <th className="cell">Module enseigné</th>
                  <th className="cell">Contact(s)</th>
                  <th className="cell">Date modifcation</th>
                  <th className="cell">Action</th>
                </tr>
              </thead>
              <tbody>
                {enseignants.length > 0 &&
                  enseignants.map((item, index) => (
                    <tr key={index}>
                      <td className="cell">
                        {item.personnes.numeromatriculePersonne}
                      </td>
                      <td className="cell">
                        {item.personnes.nomPersonne +
                          " " +
                          item.personnes.prenomsPersonne}
                      </td>
                      <td className="cell">{item.personnes.ddn ? formatDate(item.personnes.ddn):'N/A'}</td>
                      <td className="cell">{item.sexes.libelleSexe}</td>
                      <td className="cell">{item.diplomeEnseignant}</td>
                      <td className="cell">{item.matieres.libelleMatiere}</td>
                      <td className="cell">
                        {item.personnes.telephonePersonne}
                      </td>
                      <td className="cell">
                        <span>
                          {dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}
                        </span>
                      </td>
                      <td className="cell">
                        <div className="d-flex">
                          <Button
                            className="btn btn-sm rounded-5"
                            variant="success"
                            onClick={() => handleDetails(item.id)}
                            title="Détails"
                          >
                            <FontAwesomeIcon icon="fa-solid fa-list" />
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            className="btn btn-sm"
                            variant="primary"
                            onClick={() => goToEdit(item.id)}
                            title="Modifier"
                          >
                            <i className="fas fa-edit"></i>
                          </Button>{" "}
                          &nbsp;&nbsp;
                          <Button
                            className="btn btn-sm"
                            variant="danger"
                            onClick={() => onDelete(item.id)}
                            title="Supprimer"
                          >
                            <i className="fas fa-trash"></i>
                          </Button>{" "} &nbsp;&nbsp;

                          <Button
                            className="btn btn-sm"
                            variant="secondary"
                            onClick={() => handleClickemploidutemps(item.id)}
                            title="consulter emploi du temps"
                          >
                            <i className="pi pi-bookmark"></i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {/*/ Responsive Datatable */}
        {/* /Bootstrap Validation */}

        <>
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title className="text-white">
                Détails d'un enseignant
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                      <img
                        className="me-2"
                        src="/images/logo_gs_sans_fond.png"
                        alt=""
                        style={{ width: "24%", textAlign: "center" }}
                      />
                    </div>
                    <div className="col-md-6 mt-4">
                    <Button variant="outline-warning"  onClick={() => handleClickemploidutemps(idenseignant)}>
                      Consulter son emploi du temps
                    </Button>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 text-center">
                  <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">
                    Renseignements personnels
                  </h5>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      <div
                        className="col-md-6"
                        style={{
                          borderRight: "1px solid rgb(225, 224, 224)",
                        }}
                      >
                        <div className="col-md-12 ">
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="nomprenoms"
                              >
                                Nom & Prénom (s)
                              </Form.Label>
                              <Form.Control
                                className=""
                                value={nom + " " + prenoms}
                                aria-label="nomprenoms"
                                type="text"
                                readOnly
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 mb-3">
                          <Form.Label
                            className="form-label fw-bold"
                            htmlFor="email"
                          >
                            Email
                          </Form.Label>
                          <Form.Control
                            className=""
                            value={email}
                            name="email"
                            aria-label="email"
                            type="text"
                            readOnly
                            disabled
                          />
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="sexeId"
                            >
                              Sexe
                            </Form.Label>
                            <Form.Control
                              className=""
                              value={sexe}
                              name="sexe"
                              aria-label="sexe"
                              readOnly
                              disabled
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="civilite"
                            >
                              Civilité
                            </Form.Label>
                            <Form.Control
                              className=""
                              value={civilite}
                              name="civilite"
                              aria-label="civilite"
                              readOnly
                              disabled
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label  fw-bold"
                              htmlFor="telephone"
                            >
                              Telephone
                            </Form.Label>
                            <Form.Control
                              className=""
                              value={telephone}
                              name="telephone"
                              aria-label="telephone"
                              type="text"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6" style={{}}>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="ifuEnseignant"
                            >
                              IFU
                            </Form.Label>
                            <Form.Control
                              className="form-control"
                              id="ifuEnseignant"
                              type="number"
                              value={ifuEnseignant}
                              placeholder=""
                              readOnly
                              disabled
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="cnssEnseignant"
                            >
                              CNSS
                            </Form.Label>
                            <Form.Control
                              className="form-control"
                              id="cnssEnseignant"
                              type="text"
                              value={cnssEnseignant}
                              readOnly
                              disabled
                            />
                          </div>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="nationalite"
                              >
                                Nationalite
                              </Form.Label>
                              <Form.Control
                                className=""
                                value={nationalite}
                                name="nationalite"
                                aria-label="nationalite"
                                readOnly
                              />
                            </div>
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="pays"
                              >
                                Pays de residence{" "}
                              </Form.Label>
                              <Form.Control
                                className=""
                                value={pays}
                                name="pays"
                                aria-label="pays"
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="bs-validation-ddn"
                            >
                              Date de naissance
                            </Form.Label>
                            <Form.Control
                              className="form-control"
                              id="ddn"
                              value={formatDate(ddn)}
                              placeholder=""
                              name="ddn"
                              readOnly
                            />
                          </div>

                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="lieuNaissance"
                            >
                              Lieu de naissance
                            </Form.Label>
                            <Form.Control
                              id="lieuNaissance"
                              className="form-control"
                              value={lieuNaissance}
                              type="text"
                              placeholder=""
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="mr-0" />
                <div className="col-md-12 text-center">
                  <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">
                    Diplôme et compétences
                  </h5>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      <div
                        className="col-md-6"
                        style={{
                          borderRight: "1px solid rgb(225, 224, 224)",
                        }}
                      >
                        <div className="row">
                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="diplomeEnseignant"
                            >
                              Diplôme
                            </Form.Label>
                            <Form.Control
                              className="form-control"
                              id="diplomeEnseignant"
                              type="text"
                              value={diplomeEnseignant}
                              placeholder=""
                              readOnly
                            />
                          </div>
                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="typecontrat"
                            >
                              Type de contrat
                            </Form.Label>
                            <Form.Control
                              className=""
                              value={typecontrat}
                              name="typecontrat"
                              aria-label="typecontrat"
                              readOnly
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="debutcontratEnseignant"
                            >
                              Date Début Contrat{" "}
                            </Form.Label>
                            <Form.Control
                              className="form-control"
                              id="debutcontratEnseignant"
                              value={formatDate(debutcontratEnseignant)}
                              readOnly
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="bs-validation-fincontratEnseignant"
                            >
                              Date Fin Contrat
                            </Form.Label>
                            <Form.Control
                              className="form-control"
                              id="fincontratEnseignant"
                              value={formatDate(fincontratEnseignant)}
                              placeholder=""
                              name="fincontratEnseignant"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="salaireEnseignant"
                            >
                              Revenu mensuel
                            </Form.Label>
                            <Form.Control
                              className="form-control"
                              id="salaireEnseignant"
                              type="number"
                              value={salaireEnseignant}
                              readOnly
                            />
                          </div>

                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="matiereId"
                            >
                              Matière enseigné &nbsp; &nbsp;
                            </Form.Label>
                            <Form.Control
                              className=""
                              value={matiere}
                              name="matiere"
                              aria-label="matiere"
                              type="text"
                              readOnly
                            />
                          </div>
                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="classe"
                            >
                              Classe &nbsp;
                            </Form.Label>
                            <Form.Control
                              className=""
                              onChange={(e) => setEmail(e.target.value)}
                              value={classe}
                              name="classe"
                              aria-label="classe"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="col-md-8 mt-4 ">
                  <div className="row"></div>
                </div>
              </Form>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Fermer
                </Button>
                <Button
                  variant="primary"
                  type="button"
                  onClick={() => goToEdit(idElement)}
                >
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal.Body>
          </Modal>
        </>
      </div>
    </Layout>
  );
}
